<template>


  <div>
    <v-stepper v-model="e6" vertical style="border:0;box-shadow:none;">
      <v-stepper-step

              step="1"
      >
       In your browser, while connected to the router's network, navigate to your router admin console
      </v-stepper-step>

      <v-stepper-content step="10">
        In most cases it will be on of the following:
        <ul>
          <li>http://192.168.1.1</li>
          <li>http://192.168.0.1</li>
        </ul>

      </v-stepper-content>


      <v-stepper-step step="2"
      >
       Sign in to the router's console.
      </v-stepper-step>

      <v-stepper-content step="10">


      </v-stepper-content>



      <v-stepper-step step="3" >
        At the top menu, click "Advanced" then "Static route"
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

      <v-stepper-step step="4" >
        Click on "Add route"
      </v-stepper-step>

      <v-stepper-content step="10">



      </v-stepper-content>

      <v-stepper-step step="5" >
        Enter the following details, and click "Apply"
      </v-stepper-step>

      <v-stepper-content step="10">
        Name: Google1<br>
        Destination Network: 8.8.8.8<br>
        Mask: 255.255.255.255<br>
        Gateway: Your router default IP, Usually: 192.168.1.1<br>
        Metric: 2<br>
        Interface: WAN
      </v-stepper-content>

      <v-stepper-step step="6" >
        Repeat the process with the following settings
      </v-stepper-step>

      <v-stepper-content step="10">
        Name: Google2<br>
        Destination Network: 8.8.4.4<br>
        Mask: 255.255.255.255<br>
        Gateway: Your router default IP, Usually: 192.168.1.1<br>
        Metric: 2<br>
        Interface: WAN
      </v-stepper-content>

      <v-stepper-step step="7" >
        Restart the router.
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

    </v-stepper>


  </div>


</template>

<style scoped>

  >>> .v-stepper__label {
    color: rgba(0, 0, 0, 0.87)!important;
  }

</style>

<script>



  // import i18n from '@/i18n';
  // import Page from '../mixins/page'


  export default {
    title: "Block IP address on DLink",
    name: 'block-ip-address/dlink',
    data: ()=>({
      e6:10
    }),
    components: {



    }
  };
</script>
